import axios from "axios";
import { baseUrl } from "./baseUrl";
import { getPartnerToken } from "./auth";

const supportApi = axios.create({
    baseURL: `${baseUrl}/partner/support`,
});

// Add auth token to requests
supportApi.interceptors.request.use((config) => {
    const token = getPartnerToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Get All Support Tickets
export const getSupportTickets = async () => {
    try {
        const response = await supportApi.get('/get-support-tickets');
        return response.data.data;
    } catch (error) {
        console.error("Error fetching support tickets:", error);
        throw error;
    }
}

// Get Support Ticket Details
export const getSupportTicketDetails = async (ticketId) => {
    try {
        const response = await supportApi.get(`/get-ticket-details/${ticketId}`);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching support ticket details:", error);
        throw error;
    }
}

// Create Support Ticket
export const createSupportTicket = async (data) => {
    try {
        const response = await supportApi.post('/create-support-ticket', data);
        return response.data;
    } catch (error) {
        console.error("Error creating support ticket:", error);
        throw error;
    }
}

// Update Support Ticket (Note: Backend route not implemented yet)
export const updateSupportTicket = async (ticketId, data) => {
    try {
        const response = await supportApi.put(`/update-ticket/${ticketId}`, data);
        return response.data;
    } catch (error) {
        console.error("Error updating support ticket:", error);
        throw error;
    }
}
